import { useState, useEffect } from "react";
import orionAPI from "../config/orionAPI";

const useBlogPosts = (queryParams = {}) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loadingBlogPosts, setLoadingBlogPosts] = useState(true);

  const fetchBlogPosts = async () => {
    setLoadingBlogPosts(true);
    try {
      const params = new URLSearchParams(queryParams);
      const response = await orionAPI.get(`/api/blog/posts?${params}`);
      setBlogPosts(response.data.data || []);
    } catch (error) {
      console.error("Error fetching blog posts:", error);
      setBlogPosts([]);
    } finally {
      setLoadingBlogPosts(false);
    }
  };

  useEffect(() => {
    fetchBlogPosts();
  }, [JSON.stringify(queryParams)]);

  return { blogPosts, loadingBlogPosts };
};

export default useBlogPosts;
